import api from "./api";

export class SubscriptorService {
  async saveSubscriptor(form) {
    return await api.post(`/save-subcriptor`, form).then((res) => res.data);
  }
}
